import { api, getAuthHeader } from './help';

export const getEmail = async (data) => {
  const response = await api.post('/invitations', data, getAuthHeader());
  return response.data;
};

export const getEmailDetail = async (emailId) => {
  const response = await api.get(`/invitations/detail/${emailId}`, getAuthHeader());
  return response.data;
};

export const deleteEmail = async (data) => {
  const response = await api.delete('/invitations?id=' + data, getAuthHeader());
  return response.data;
};
